import { SendOutlined } from "@ant-design/icons";
import { Button, Flex, Input } from "antd";
import { useState } from "react";

interface Props {
  onSend: (text: string) => void;
  loading?: boolean;
}

const SupportMessageInput = ({ onSend, loading }: Props) => {
  const [text, setText] = useState("");

  const handleSend = () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    onSend(trimmed);
    setText("");
  };

  return (
    <Flex gap={8}>
      <Input.TextArea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Введите сообщение..."
        autoSize={{ minRows: 1, maxRows: 4 }}
        onPressEnter={(e) => {
          if (!e.shiftKey) {
            e.preventDefault();
            handleSend();
          }
        }}
      />
      <Button type="primary" icon={<SendOutlined />} onClick={handleSend} loading={loading} />
    </Flex>
  );
};

export default SupportMessageInput;
